import { cn } from '@/utlis/cn'
import { ParticipantTile, ParticipantTileProps } from '@livekit/components-react'
import { useEffect, useState } from 'react'

export default function Tile(props: ParticipantTileProps) {
    const [enabled, setEnabled] = useState<boolean>(true)
    useEffect(() => {
        const h = (s: any) => setEnabled(!s.disabled)
        props.trackRef?.publication?.on('updateSettings', h)
        return () => {
            props.trackRef?.publication?.off('updateSettings', h)
        }
    }, [props.trackRef?.publication])

    if (!enabled || !props.trackRef?.publication || !props.trackRef?.publication.isEnabled) {
        const name = props.trackRef?.participant.name
        const identity = props.trackRef?.participant.identity
        return (
            <div
                className={cn(
                    'w-[15vw]" bg-neutral-600 flex items-center justify-center font-bold',
                    props.className,
                    props.trackRef?.participant.isSpeaking && 'border-3 border-muse-yellow'
                )}
            >
                {name ?? identity}
            </div>
        )
    }

    return <ParticipantTile {...props} />
}
